import { HTTP } from '@/common/utils/http';

export const ParentsService = {
    getParents(schoolId) {
        return HTTP.get(`schools/${schoolId}/parents/customers`);
    },

    getParentsCount(schoolId) {
        return HTTP.get(`/schools/${schoolId}/parents/amount`);
    },

    getKidsCount(schoolId) {
        return HTTP.get(`/schools/${schoolId}/children/amount`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/pages/parents.service.js